export enum GroupByDateFormat {
		Day	=	0,
		Week	=	1,
		Month	=	2,
		Quarter	=	3,
}
